module.exports = __webpack_public_path__ + "img/SmartGoals_Logo.fa082816.png";